export const MOMENTJS_DATE_FORMAT = 'Do MMMM YYYY';
export const MOMENTJS_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const MOMENTJS_DATE_FORMAT_STANDARD = 'DD/MM/YYYY';
export const MOMENTJS_DATE_FORMAT_REVERSED = 'YYYY-MM-DD';

export const ERROR_TIMESTAMP_NOT_NUMBER = 'Exception : timestamp is not a number.';
export const ERROR_DATE_NOT_VALID_MOMENTJS = 'Exception : date is not a valid momentjs object.';
export const ERROR_STRING_NULL = 'Exception : string is null';



// WEBPACK FOOTER //
// ./src/constants/moment.js